import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const OrdersListAsync = RouterSuspense(
  lazy(() => import('./index.tsx')),
);
